import { sample } from 'effector';
import { receivedNotification, signout } from '@features/common';
import { $isPopperVisible, setPopperVisiblity } from '../main/model';
import { PopperVisiblity } from '../main/types';
import {
  $contactCalls,
  CALL_EVENT,
  clearEndedCalls,
  fxClearEndedCalls,
  fxGetContactCalls,
} from './model';

$contactCalls.on(fxGetContactCalls.doneData, (_, { calls }) => calls).reset([signout]);

sample({
  clock: $isPopperVisible,
  filter: (visibilityStatus) => visibilityStatus === 'all',
  target: fxGetContactCalls,
});

sample({
  clock: fxClearEndedCalls.done,
  target: fxGetContactCalls,
});

const receivedCallEvent = sample({
  clock: receivedNotification,
  filter: (receivedNotification) => (receivedNotification as any).event === CALL_EVENT,
});

sample({
  clock: receivedCallEvent,
  fn: (receivedNotification) => [(receivedNotification as any).payload],
  target: $contactCalls,
});

sample({
  clock: receivedCallEvent,
  fn: () => 'alert' as PopperVisiblity,
  target: setPopperVisiblity,
});

sample({
  clock: clearEndedCalls,
  target: fxClearEndedCalls,
});
